module.exports = __webpack_public_path__ + "static/media/siddhi.dd8e315e.png";